import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button/Button'
import { AbsolutePopup, PopPaper, TPopupVertical } from 'core-components/library/popup'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { CockpitDocumentLinks } from '../cockpitDocumentLinks/CockpitDocumentLinks'

import styles from './DocumentsTreeLinks.module.scss'

export const DocumentsTreeLinks = () => {
  return (
    <AbsolutePopup
      rootClassName={styles.root}
      popupClassName={styles.popupWrap}
      verticalStartPosition={TPopupVertical.Bottom}
      popupContent={({ action }) => (
        <PopPaper shadowPosition="auto" className={styles.popup}>
          <div onClick={() => action.close()}>
            <CockpitDocumentLinks />
          </div>
        </PopPaper>
      )}
    >
      <Button color={'grey'} icon="kbase kbase-link">
        <span className={styles.triggerContent}>
          <Translation
            span
            text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.sectionLinks}
          />
          <i className="kbase kbase-chevron-bottom" />
        </span>
      </Button>
    </AbsolutePopup>
  )
}
